import { Directive, Input, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[tiptool]'
})
export class ToolTipDirective {
  @Input('tiptool') tooltipTitle: string;
  @Input() placement: string;
  @Input() disableTooltips = false;
  tooltip: HTMLElement;
  offset = 10;
  delay = 500;
  isMouseOverTooltip = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    // empty
  }

  @HostListener('mouseenter') onMouseEnter() {
    if (!this.tooltip && !this.disableTooltips) {
      this.show();
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.tooltip && !this.disableTooltips) {
      setTimeout(() => {
        if (this.tooltip && !this.isMouseOverTooltip) {
          // Überprüfung hinzufügen
          this.hide();
        }
      }, this.delay); // Verzögerung vor dem Ausblenden
    }
  }

  show() {
    this.create();
    this.setPosition();
    this.renderer.addClass(this.tooltip, 'cms-tooltip-show');
  }

  hide() {
    this.renderer.removeClass(this.tooltip, 'cms-tooltip-show');
    window.setTimeout(() => {
      this.renderer.removeChild(document.body, this.tooltip);
      this.tooltip = null;
    }, this.delay);
  }

  create() {
    this.tooltip = this.renderer.createElement('div');
    this.tooltip.innerHTML = this.tooltipTitle; // Setzen von HTML-Inhalt

    this.renderer.appendChild(document.body, this.tooltip);
    // this.renderer.appendChild(this.el.nativeElement, this.tooltip);

    this.renderer.addClass(this.tooltip, 'cms-tooltip');
    this.renderer.addClass(this.tooltip, `cms-tooltip-${this.placement}`);
    this.renderer.setStyle(this.tooltip, 'z-index', '2000');

    // delay
    this.renderer.setStyle(this.tooltip, '-webkit-transition', `opacity ${this.delay}ms`);
    this.renderer.setStyle(this.tooltip, '-moz-transition', `opacity ${this.delay}ms`);
    this.renderer.setStyle(this.tooltip, '-o-transition', `opacity ${this.delay}ms`);
    this.renderer.setStyle(this.tooltip, 'transition', `opacity ${this.delay}ms`);

    // Im create():
    this.renderer.listen(this.tooltip, 'mouseenter', () => (this.isMouseOverTooltip = true));
    this.renderer.listen(this.tooltip, 'mouseleave', () => {
      this.isMouseOverTooltip = false;
      this.hide();
    });
  }

  setPosition() {
    const hostPos = this.el.nativeElement.getBoundingClientRect();

    const tooltipPos = this.tooltip.getBoundingClientRect();

    const scrollPos =
      window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    let top, left;

    if (this.placement === 'top') {
      top = hostPos.top - tooltipPos.height - this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (this.placement === 'bottom') {
      top = hostPos.bottom + this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (this.placement === 'left') {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.left - tooltipPos.width - this.offset;
    }

    if (this.placement === 'right') {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.right + this.offset;
    }

    this.renderer.setStyle(this.tooltip, 'top', `${top + scrollPos}px`);
    this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
  }
}
